import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/italic-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M19 3C19.5523 3 20 3.44772 20 4C20 4.55228 19.5523 5 19 5H15.6934L10.4434 19H14C14.5523 19 15 19.4477 15 20C15 20.5523 14.5523 21 14 21H5C4.44772 21 4 20.5523 4 20C4 19.4477 4.44772 19 5 19H8.30664L13.5566 5H10C9.44772 5 9 4.55228 9 4C9 3.44772 9.44772 3 10 3H19Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as Italic01Icon };
